export interface Described {
  detail: string;
  hint: string;
}

export const DEFAULT_HINT = "Retry; if it fails again, check logs/backend.log.";

export function describeError(error: unknown): Described {
  const detail = error instanceof Error ? error.message : String(error);
  const hint =
    error && typeof error === "object" && "hint" in error && typeof error.hint === "string" ? error.hint : DEFAULT_HINT;
  return { detail: detail || "The request failed without a message.", hint };
}

export function clockTime(at: number): string {
  const d = new Date(at);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
